import { clsx } from 'clsx'
import { type FC, type ReactElement, type ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { SvgArrowDown } from '../../../../../erx-landing-page'
import { StaticImage } from '../../../../../image'

import Step1Image from './01-concent.png'
import Step2Image from './02-rx.png'
import Step3Image from './03-freeDelivery.png'
import { RxLpChHowToLink } from './RxLpChLink'
import { RxLpChHowToPoint } from './RxLpChPoint'

import styles from './HowTo.module.css'

const accent = (text: ReactNode[]): ReactElement => {
  return <span className="font-medium italic text-dark-brand">{text}</span>
}

const lineBreak = (): ReactElement => {
  return <br />
}

export const RxLpChHowTo: FC = () => {
  const intl = useIntl()

  return (
    <div className="tablet:flex tablet:justify-center">
      <div
        className={clsx(
          styles['how-to'],
          'container flex-col px-4 py-6 tablet:px-0 tablet:py-12',
        )}
      >
        <div
          className={clsx(styles['how-to-title'], 'text-2xl tablet:text-3xl')}
        >
          <FormattedMessage id="rx.ch.howto.title" />
        </div>
        <div
          className={clsx(
            styles['how-to-content'],
            'flex-col gap-6 tablet:flex-row',
          )}
        >
          <RxLpChHowToPoint
            content={[
              <FormattedMessage
                id="rx.ch.howto.step.1.description.top"
                key="rx.ch.howto.step.1.description.top"
              />,
              <FormattedMessage
                id="rx.ch.howto.step.1.description.bottom"
                key="rx.ch.howto.step.1.description.bottom"
                values={{ link: RxLpChHowToLink }}
              />,
            ]}
            image={Step1Image}
            title={intl.formatMessage({ id: 'rx.ch.howto.step.1.title' })}
          />
          <StaticImage
            alt="Arrow"
            className="tablet:-rotate-90"
            height={40}
            src={SvgArrowDown}
          />
          <RxLpChHowToPoint
            content={[
              <FormattedMessage
                id="rx.ch.howto.step.2.description.top"
                key="rx.ch.howto.step.2.description.top"
                values={{
                  accentuateHighlight: accent,
                }}
              />,
              <FormattedMessage
                id="rx.ch.howto.step.2.description.bottom"
                key="rx.ch.howto.step.2.description.bottom"
                values={{
                  br: lineBreak,
                }}
              />,
            ]}
            image={Step2Image}
            title={intl.formatMessage({ id: 'rx.ch.howto.step.2.title.new' })}
          />
          <StaticImage
            alt="Arrow"
            className="tablet:-rotate-90"
            height={40}
            src={SvgArrowDown}
          />

          <RxLpChHowToPoint
            content={[
              <FormattedMessage
                id="rx.ch.howto.step.3.description.top.new"
                key="rx.ch.howto.step.3.description.top.new"
                values={{
                  accentuateHighlight: accent,
                }}
              />,
            ]}
            image={Step3Image}
            title={intl.formatMessage({ id: 'rx.ch.howto.step.3.title.new' })}
          />
        </div>
      </div>
    </div>
  )
}
